import { NumberFormatter } from 'field-kit';
export default class PercentageFormatter extends NumberFormatter {
  constructor() {
    super();
    this.setNumberStyle(NumberFormatter.Style.PERCENT); /** indicates PERCENT */
  }
  isChangeValid(change, error) {
    const percentSymbol = this.percentSymbol();

    /** check if no % when user enter, then add % after the number */
    if (!change.proposed.text.includes(percentSymbol)) {
      let text;
      /** check if the input is a digit */
      if (/^\d*$/.test(change.proposed.text)) {
        text = change.proposed.text + percentSymbol;
      } else {
        text = '';
      }
      change.proposed = {
        text,
        selectedRange: {
          start: text.length - 1,
          length: 0
        }
      };
      return super.isChangeValid(change, error);
    }
    /** not allow user to delete % */
    if (/${percentSymbol}/.test(change.deleted.text)) {
      const text = change.current.text;
      change.proposed = {
        text,
        selectedRange: {
          start: text.length - 1,
          length: 0
        }
      };
      return super.isChangeValid(change, error);
    }
    /** user enter amount greater than 100, then change the value to 100 */
    if (Number(change.proposed.text.replace(percentSymbol, '')) > 100) {
      const text = `100${percentSymbol}`;
      change.proposed = {
        text,
        selectedRange: {
          start: text.length,
          length: 0
        }
      };
      return super.isChangeValid(change, error);
    }

    /** validate the input value is in 00.00 formate */
    if (/^(?:100(?:\.00?)?|\d?\d(?:\.\d\d?)?)$/.test(Number(change.proposed.text.replace(percentSymbol, '')).toString())) {
      return true;
    }
    return false;
  }
  parse(str) {
    return str.replace(this.percentSymbol(), '');
  }
  format(number) {
    if (number != null) {
      return number.toString() + this.percentSymbol();
    } else {
      return '';
    }
  }
}